import LoopSlider from "./LoopSlider";
import Swiper from "swiper";
import {
	Pagination,
	Autoplay,
	Navigation,
	EffectFade,
	Thumbs,
	Scrollbar,
} from "swiper/modules";

$(document).ready(() => {
	const bannerSlider = new Swiper(".banner-slider .swiper", {
		modules: [Autoplay, Navigation, EffectFade],
		slidesPerView: 1,
		effect: "fade",
		autoplay: {
			delay: 4000,
		},
		speed: 800,
		loop: true,
		navigation: {
			prevEl: ".banner-slider .swiper-btn-prev",
			nextEl: ".banner-slider .swiper-btn-next",
		},
	});

	const homeFeaturedSlider = new Swiper(".home-featured-slider .swiper", {
		modules: [Navigation],
		slidesPerView: 1,
		spaceBetween: 40,
		speed: 800,
		navigation: {
			prevEl: ".home-featured-slider .swiper-btn-prev",
			nextEl: ".home-featured-slider .swiper-btn-next",
		},
		on: {
			transitionEnd: function () {
				const activeSlide = $(
					".home-featured-slider .swiper-slide-active"
				);
				$(".home-featured-slider .featured-product").removeClass(
					"active"
				);
				activeSlide.find(".featured-product").addClass("active");
			},
			init: function () {
				const activeSlide = $(
					".home-featured-slider .swiper-slide-active"
				);
				$(".home-featured-slider .featured-product").removeClass(
					"active"
				);
				activeSlide.find(".featured-product").addClass("active");
			},
		},
	});

	const singleSlider = new LoopSlider(".single-slider", {
		1024: {
			spaceBetween: 40,
			slidesPerView: 1,
		},
	});

	const doubleSlider = new LoopSlider(".double-slider", {
		576: {
			spaceBetween: 20,
			slidesPerView: 1.5,
		},
		1024: {
			spaceBetween: 40,
			slidesPerView: 2,
		},
	});

	const tripleSlider = new LoopSlider(".triple-slider", {
		576: {
			spaceBetween: 20,
			slidesPerView: 2.5,
		},
		1024: {
			spaceBetween: 40,
			slidesPerView: 3,
		},
	});

	const quadrupleSlider = new LoopSlider(".quadruple-slider", {
		576: {
			spaceBetween: 20,
			slidesPerView: 2.5,
		},
		768: {
			spaceBetween: 20,
			slidesPerView: 3.5,
		},
		1024: {
			spaceBetween: 40,
			slidesPerView: 4,
		},
	});
});
